import React from "react";
import { Button, Stack } from "@mui/material";
import { Modal, Typography, useTranslation } from "@unicity/design-system";
import { T } from "../../hooks/useTranslate";

/**
 * GO-3079 — "Reset application" confirmation modal.
 *
 * Refresh-only (per ticket; the logout clause was struck through). Confirming
 * triggers a hard reload of the app, which drops the in-memory API cache
 * (GO-3121) and re-runs the bootstrap `office-web-cache:*` purge in index.tsx —
 * i.e. "resets your cache for this application" without signing the user out.
 */
const ResetApplicationModal = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("reset_application")}
      open={open}
      onClose={onClose}
      aria-labelledby="modal-reset-application"
      aria-describedby="modal-reset-application-desc"
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "rgba(0,0,0,0.2)" },
        },
      }}
      sx={{
        "& h2.MuiTypography-root.MuiTypography-h2": {
          fontSize: "calc(1rem * var(--unicity-font-scale, 1)) !important",
          fontWeight: "500",
        },
      }}
    >
      <Stack
        data-test-id="reset-application-modal"
        gap={3}
        sx={{ padding: "0px 12px", maxWidth: "360px" }}
      >
        <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
          <T>reset_application_confirm</T>
        </Typography>
        <Stack direction="row" justifyContent="flex-end" gap={1}>
          <Button
            id="reset-application-cancel"
            data-test-id="reset-application-cancel-button"
            aria-label="cancel reset application"
            sx={{
              backgroundColor: "transparent",
              paddingLeft: "12px",
              paddingRight: "12px",
            }}
            onClick={onClose}
          >
            <T>cancel</T>
          </Button>
          <Button
            id="reset-application-confirm"
            data-test-id="reset-application-confirm-button"
            aria-label="confirm reset application"
            sx={{
              color: "#FFFFFF",
              backgroundColor: "#009ECF",
              borderRadius: "4px",
              paddingLeft: "12px",
              paddingRight: "12px",
              "&:hover": {
                backgroundColor: "rgba(0, 158, 198, 0.48)",
              },
            }}
            onClick={onConfirm}
          >
            <T>yes</T>
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export { ResetApplicationModal };
